export default "__VITE_ASSET__DvH_Ezku__"